<template>

  <div

    class="ni-change-lang"
    :class="{
      'ni-change-lang--on-hero': tone === 'light',
      'ni-change-lang--compact': compact,
    }"

    @mousedown.stop="rememberScroll"
    @focusin="preventScrollJump"
    @click.stop

  >

    <span v-if="showIcon" class="ni-header__lang-icon">

      <img

        :src="newIndexLocaleSwitchIcon"

        alt=""

        class="ni-change-lang__icon"

      />

    </span>

    <span v-if="compact" class="ni-change-lang__label">{{ currentLabel }}</span>

    <el-select

      id="ni-language-select"

      v-model="value"

      placeholder="Select"

      :teleported="true"

      :popper-options="{ strategy: 'fixed' }"

      @visible-change="onVisibleChange"

      @change="switchLang"

    >

      <el-option

        v-for="item in options"

        :key="item.value"

        :label="item.label"

        :value="item.value"

      />

    </el-select>

  </div>

</template>



<script setup>

import { useRoute } from 'vue-router';

import { useI18n } from 'vue-i18n';

import { computed, ref } from 'vue';

import i18n from '@/lang/index';
import { newIndexLocaleSwitchIcon } from '@/data/newIndexAssets.js';



defineProps({

  compact: {

    type: Boolean,

    default: false,

  },

  showIcon: {

    type: Boolean,

    default: true,

  },

  tone: {

    type: String,

    default: '',

  },

});



const route = useRoute();

const { locale } = useI18n();

const value = ref(i18n.global.locale.value);

let savedScrollTop = 0;



const options = [

  { value: 'zh', label: '中文简体' },

  { value: 'zhCHT', label: '中文繁体' },

  { value: 'en', label: 'English' },

  { value: 'ja', label: '日本語' },

  { value: 'ko', label: '한국어' },

  { value: 'ru', label: 'Русский язык' },

  { value: 'de', label: 'Deutsche Sprache' },

  { value: 'ar', label: 'اللغة العربية' },

];

const currentLabel = computed(() => {
  const opt = options.find((item) => item.value === value.value);
  return opt ? opt.label : '';
});



function getScrollElement() {

  const page = document.querySelector('.ni-page');

  if (page && page.scrollHeight > page.clientHeight + 1) {

    return page;

  }

  return document.scrollingElement || document.documentElement;

}



function rememberScroll() {

  savedScrollTop = getScrollElement().scrollTop;

}



function restoreScroll() {

  getScrollElement().scrollTop = savedScrollTop;

}



function preventScrollJump() {

  rememberScroll();

  requestAnimationFrame(restoreScroll);

}



function onVisibleChange(visible) {

  if (!visible) return;

  requestAnimationFrame(() => {

    restoreScroll();

    requestAnimationFrame(restoreScroll);

  });

}



function switchLang(lang) {

  locale.value = lang;

  localStorage.setItem('lang', lang);

  let baseUrl = `${location.protocol}//${location.hostname}`;

  if (location.port) {

    baseUrl += `:${location.port}`;

  }

  baseUrl += route.fullPath;

  location.href = baseUrl;

}

</script>



<style scoped>

.ni-change-lang {

  display: flex;

  align-items: center;

  gap: 0.375rem;

}



.ni-change-lang__icon {

  width: 1.25rem;

  height: 1.25rem;

  object-fit: contain;

  display: block;

}



.ni-change-lang--compact :deep(.el-select__wrapper) {

  min-width: 0;

  width: 1.125rem;

  padding: 0;

}



.ni-change-lang--compact :deep(.el-select__selected-item) {

  display: none;

}



.ni-change-lang--compact :deep(.el-select__placeholder) {

  display: none;

}



.ni-change-lang__label {

  font-size: var(--ni-font-base, 14px);

  font-weight: 400;

  color: #374151;

  white-space: nowrap;

  line-height: 1.2;

}



:deep(.el-select) {

  --el-select-border-color-hover: transparent;

  --el-select-input-focus-border-color: transparent;

}



:deep(.el-select__wrapper) {

  background-color: transparent;

  box-shadow: none !important;

  outline: none;

  border: none;

  color: #111827;

  padding: 4px 4px 0;

  min-width: 100px;

  font-size: 14px;

  scroll-margin: 0;

}



:deep(.el-select__wrapper.is-hovering:not(.is-focused)),

:deep(.el-select__wrapper:hover),

:deep(.el-select__wrapper.is-focused) {

  box-shadow: none !important;

  outline: none;

}



:deep(.el-select__placeholder),

:deep(.el-select__selected-item) {

  color: #111827;

}



.ni-change-lang--on-hero :deep(.el-select__placeholder),

.ni-change-lang--on-hero :deep(.el-select__selected-item),

.ni-change-lang--on-hero :deep(.el-select__suffix),

.ni-change-lang--on-hero :deep(.el-select__caret),

.ni-change-lang--on-hero :deep(.el-select__wrapper) {

  color: #fff;

}



:deep(.el-select__suffix),

:deep(.el-select__caret) {

  color: #374151;

}



:deep(.el-icon) {

  width: 12px;

  height: 12px;

  line-height: 12px;

  padding-top: 4px;

}



:deep(.el-icon svg) {

  width: 12px;

  height: 12px;

}

</style>


